export const appRouteNames = {
  HOME: '',
  LOGIN: 'login',
  ERROR: 'error',
  INFO: 'info',
  PUBLIC: 'public',
  PROFILE: 'user/profile',
  SESSION_LIST: 'sessions',
};
